import ResetLink from "./ResetLink";
import { Link } from "../../../../common/components/Link";
import { getRedirectToRegisterPage, redirectOrReload } from "../../../../utils/url/urlUtils";
import { useSelector } from "react-redux";
import { selectIsSaveConfigurationEnabled } from "../../../Linear/redux/selectors";
import { useSaveConfigPopup } from "../../../Linear/hooks/useSaveConfigPopup";
import { userIsPublic } from "../../../../utils/roles";
import { REGISTER_PAGE, SAVED_CONFIGS_PAGE } from "../../../../utils/url/staticUrls";
import { useTrackLCSimpleButtonClick } from "../../../Linear/hooks/useTrackLCClicks";
import Card, { CardSize } from "../../../../common/components/Card";
import { IconType } from "../../../../common/components/icon/IconType";
import { Icon } from "../../../../common/components/icon/Icon";
import { useTranslation } from "react-i18next";
import { Stacker } from "~/common/components/Stacker/Stacker";

const LinearLinks = () => {
  const isPublicUser = userIsPublic();
  const { t } = useTranslation();

  return (
    <Card size={CardSize.SMALL} className={"scha__linear-configurator__header__links"}>
      <span className={"scha__lc-myconfiguration"}>{t("page.linear.myconfiguration")}</span>
      <Stacker className={"scha__lc-container-links"} gap={24} direction={"row"}>
        <ResetLink />
        <SaveConfigurationLink isPublicUser={isPublicUser} />
        <ImportConfigurationLink isPublicUser={isPublicUser} />
      </Stacker>
    </Card>
  );
};
export default LinearLinks;

export const HelpLink = ({ url }: { url: string }) => {
  const { t } = useTranslation();

  return (
    <Link
      className={"label-large"}
      iconBefore={<Icon type={IconType.QuestionMarkCircle} />}
      href={url}
      target={"_blank"}
    >
      <span>{t("page.linear.links.help")}</span>
    </Link>
  );
};

const ImportConfigurationLink = ({ isPublicUser }: { isPublicUser: boolean }) => {
  const { t } = useTranslation();
  const trackClick = useTrackLCSimpleButtonClick("click_on_open");
  let url;
  if (isPublicUser) {
    getRedirectToRegisterPage({ targetPage: SAVED_CONFIGS_PAGE });
  } else {
    const params = new URLSearchParams();
    params.append("from", window.location.href);
    url = SAVED_CONFIGS_PAGE + "?" + params.toString();
  }
  const onClick = () => {
    trackClick();
  };

  return (
    <Link
      iconBefore={<Icon type={IconType.FolderOpen} />}
      href={isPublicUser ? REGISTER_PAGE : url}
      onClick={!isPublicUser ? onClick : trackClick}
    >
      {t("page.linear.links.import")}
    </Link>
  );
};

const SaveConfigurationLink = ({ isPublicUser }: { isPublicUser: boolean }) => {
  const { t } = useTranslation();
  const trackClick = useTrackLCSimpleButtonClick("click_on_save");
  const disableSave = !useSelector(selectIsSaveConfigurationEnabled);
  const { openModal, component } = useSaveConfigPopup();

  const onClick = (e: React.MouseEvent) => {
    e.preventDefault();
    trackClick();
    if (!isPublicUser) {
      openModal();
    } else {
      redirectOrReload(REGISTER_PAGE);
    }
  };

  return (
    <>
      <Link
        iconBefore={<Icon type={IconType.Disk} />}
        href={isPublicUser ? REGISTER_PAGE : undefined}
        disabled={isPublicUser ? false : disableSave}
        onClick={onClick}
      >
        {t("page.linear.links.saveConfig")}
      </Link>
      {component}
    </>
  );
};
